import { defineStore } from 'pinia'

export const useLaudoSettingsStore = defineStore('laudoSettings', {
  state: () => ({
    // Configurações de colunas visíveis
    colunasVisiveis: {
      nome: true,
      status: true,
      numero: true,
      exame: true,
      data: true,
      mod: true,
      medRef: true,
      laudo_medico: true,
      acoes: true
    },
    
    // Configurações de ordenação
    ordenacaoPadrao: {
      campo: 'data',
      direcao: 'desc'
    },
    
    // Configurações de paginação
    itensPorPagina: 25,
    
    // Configurações de visualização
    modoVisualizacao: 'table', // 'table' ou 'cards'
    
    // Configurações de filtros padrão
    filtrosPadrao: {
      dataInicio: '',
      dataFim: '',
      modalidadeSelecionada: '',
      statusSelecionado: 'todos'
    }
  }),

  getters: {
    // Obter lista de colunas visíveis para o componente
    getColunasVisiveis: (state) => {
      const todasColunas = [
        { id: 'nome', nome: 'Nome', ordenavel: true },
        { id: 'status', nome: 'Status', ordenavel: true },
        { id: 'numero', nome: 'OS', ordenavel: true },
        { id: 'exame', nome: 'Exame', ordenavel: true },
        { id: 'data', nome: 'Data', ordenavel: true },
        { id: 'mod', nome: 'Modalidade', ordenavel: true },
        { id: 'medRef', nome: 'Méd. Ref.', ordenavel: true },
        { id: 'laudo_medico', nome: 'Laudado por', ordenavel: true },
        { id: 'acoes', nome: 'Ações', ordenavel: false }
      ]
      
      return todasColunas.filter(coluna => state.colunasVisiveis[coluna.id])
    },
    
    // Verificar se uma coluna específica está visível
    isColunaVisivel: (state) => (colunaId) => {
      return state.colunasVisiveis[colunaId] || false
    }
  },

  actions: {
    // Atualizar visibilidade de uma coluna específica
    toggleColuna(colunaId) {
      if (Object.prototype.hasOwnProperty.call(this.colunasVisiveis, colunaId)) {
        this.colunasVisiveis[colunaId] = !this.colunasVisiveis[colunaId]
        this.salvarConfiguracoes()
      }
    },
    
    // Definir visibilidade de uma coluna específica
    setColunaVisivel(colunaId, visivel) {
      if (Object.prototype.hasOwnProperty.call(this.colunasVisiveis, colunaId)) {
        this.colunasVisiveis[colunaId] = visivel
        this.salvarConfiguracoes()
      }
    },
    
    // Atualizar todas as colunas visíveis de uma vez
    setColunasVisiveis(colunas) {
      this.colunasVisiveis = { ...colunas }
      this.salvarConfiguracoes()
    },
    
    // Definir ordenação padrão
    setOrdenacaoPadrao(campo, direcao = 'asc') {
      this.ordenacaoPadrao = { campo, direcao }
      this.salvarConfiguracoes()
    },
    
    // Definir itens por página
    setItensPorPagina(quantidade) {
      this.itensPorPagina = quantidade
      this.salvarConfiguracoes()
    },
    
    // Definir modo de visualização
    setModoVisualizacao(modo) {
      this.modoVisualizacao = modo
      this.salvarConfiguracoes()
    },
    
    // Definir filtros padrão
    setFiltrosPadrao(filtros) {
      this.filtrosPadrao = { ...filtros }
      this.salvarConfiguracoes()
    },
    
    // Salvar configurações no localStorage
    salvarConfiguracoes() {
      try {
        const configuracoes = {
          colunasVisiveis: this.colunasVisiveis,
          ordenacaoPadrao: this.ordenacaoPadrao,
          itensPorPagina: this.itensPorPagina,
          modoVisualizacao: this.modoVisualizacao,
          filtrosPadrao: this.filtrosPadrao
        }
        localStorage.setItem('laudoSettings', JSON.stringify(configuracoes))
        console.log('Configurações salvas com sucesso:', configuracoes)
      } catch (error) {
        console.error('Erro ao salvar configurações:', error)
      }
    },
    
    // Carregar configurações do localStorage
    carregarConfiguracoes() {
      try {
        const configuracoes = localStorage.getItem('laudoSettings')
        if (configuracoes) {
          const dados = JSON.parse(configuracoes)
          
          // Aplicar configurações carregadas, mantendo valores padrão se não existirem
          if (dados.colunasVisiveis) {
            this.colunasVisiveis = { ...this.colunasVisiveis, ...dados.colunasVisiveis }
          }
          
          if (dados.ordenacaoPadrao) {
            this.ordenacaoPadrao = { ...this.ordenacaoPadrao, ...dados.ordenacaoPadrao }
          }
          
          if (dados.itensPorPagina) {
            this.itensPorPagina = dados.itensPorPagina
          }
          
          if (dados.modoVisualizacao) {
            this.modoVisualizacao = dados.modoVisualizacao
          }
          
          if (dados.filtrosPadrao) {
            this.filtrosPadrao = { ...this.filtrosPadrao, ...dados.filtrosPadrao }
          }
        }
      } catch (error) {
        console.error('Erro ao carregar configurações:', error)
      }
    },
    
    // Resetar configurações para valores padrão
    resetarConfiguracoes() {
      this.colunasVisiveis = {
        nome: true,
        status: true,
        numero: true,
        exame: true,
        data: true,
        mod: true,
        medRef: true,
        laudo_medico: true,
        acoes: true
      }
      this.ordenacaoPadrao = { campo: 'data', direcao: 'desc' }
      this.itensPorPagina = 25
      this.modoVisualizacao = 'table'
      this.filtrosPadrao = {
        dataInicio: '',
        dataFim: '',
        modalidadeSelecionada: '',
        statusSelecionado: 'todos'
      }
      
      // Remover do localStorage
      try {
        localStorage.removeItem('laudoSettings')
      } catch (error) {
        console.error('Erro ao remover configurações:', error)
      }
    }
  }
})